(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
/* Native forms, variant pickers and media are never replaced or cloned. */
if (!customElements.get('flexicanap-product')) {
  customElements.define('flexicanap-product', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-fx-model]');
        if (!button) return;
        const gallery = this.querySelector('media-gallery > slideshow-component');
        const slides = Array.from(gallery?.querySelectorAll('slideshow-slides > slideshow-slide') || []);
        const index = slides.findIndex(slide => slide.querySelector('product-model, model-viewer'));
        if (index >= 0 && typeof gallery.select === 'function') {
          event.preventDefault();
          event.stopPropagation();
          gallery.select(index);
          slides[index].querySelector('product-model button')?.focus({preventScroll:true});
        }
      }, {signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.schedule());
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.mount());
    }
    make(name) {
      return this.querySelector(`template[data-fx-template="${name}"]`)?.content.firstElementChild?.cloneNode(true);
    }
    mount() {
      if (!this.isConnected) return;
      this.observer.disconnect();
      const details = this.querySelector('.product-details, [data-testid="product-information-details"], [id^="ProductInformation-"]');
      const heading = details?.querySelector('h1, h2, .product-title');
      const form = details?.querySelector('product-form-component, form[action*="/cart/add"]');
      const buy = details?.querySelector('.buy-buttons-block') || form;
      let stack = details?.querySelector(':scope > .group-block > .group-block-content, :scope > .group-block > .group-block__content, :scope > .group-block > .layout-panel-flex');
      if (!stack && heading) {
        // Atelier releases can have different wrappers. Find the shared parent
        // from rendered elements instead of requiring one specific group class.
        stack = heading.parentElement;
        while (stack && stack !== details && buy && !stack.contains(buy)) stack = stack.parentElement;
      }
      stack ||= details;
      // Insert additions beside the actual buy block, even if it sits in a nested group.
      // Never move a native custom element: that can reset its internal subscriptions.
      if (stack) {
        details.classList.add('fx-details');
        stack.classList.add('fx-details-stack');
        heading?.classList.add('fx-product-title');
        let titleBlock = heading;
        while (titleBlock && titleBlock.parentElement !== stack) titleBlock = titleBlock.parentElement;
        titleBlock?.classList.add('fx-title-block');
        this.setAttribute('data-fx-ready', '');
      }
      const gallery = this.querySelector('media-gallery.media-gallery--carousel > slideshow-component');
      const container = gallery?.querySelector('slideshow-container');
      if (container && !container.querySelector('.fx-overlay')) {
        const overlay = this.make('overlay');
        if (overlay) container.append(overlay);
      }
      if (gallery) {
        const slides = Array.from(gallery.querySelectorAll('slideshow-slides > slideshow-slide'));
        const visible = slides.filter(slide => !slide.hidden);
        const counter = gallery.querySelector('[data-fx-counter]');
        const current = slides[Number(gallery.current ?? gallery.getAttribute('initial-slide') ?? 0)];
        if (counter) {
          counter.hidden = visible.length < 2;
          counter.textContent = `${Math.max(0, visible.indexOf(current)) + 1} / ${visible.length}`;
        }
        const model = gallery.querySelector('[data-fx-model]');
        if (model) model.hidden = !visible.some(slide => slide.querySelector('product-model, model-viewer'));
      }
      // Reapply additions after native variant morphing and editor block rerenders.
      this.observer.observe(this, {childList:true, subtree:true, attributes:true,
        attributeFilter:['aria-selected','aria-hidden','hidden','initial-slide']});
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
